import { useSuspenseQuery } from '@tanstack/react-query';

import * as dp from '../data-provider/pricing-validation-schema';
import type { ValidationSchema, ValidationSchemaKey } from '../models';

export const useSuspensePricingValidationSchema = (schemaKey: ValidationSchemaKey) =>
  useSuspenseQuery({
    ...dp.validationSchemasQueryOptions(),
    select: (data): ValidationSchema => {
      if (!data[schemaKey]) {
        throw new Error(`[validators]: ${schemaKey} has not found`);
      }
      return data[schemaKey] as ValidationSchema;
    },
  });
